import ConfirmCancelModal from "./ConfirmCancelModal";
import {useForm} from "antd/lib/form/Form";
import {DatePicker, Form, message} from "antd";
import {useLazyGetUWExtractionQuery} from "../../redux/api/extractionToXlsx";
import moment from "moment";
import {Rule} from "antd/lib/form";
import {useCallback, useEffect} from "react";

export default function UnderwriterDownloadModal({
                                                     isModalVisible,
                                                     closeModal
                                                 }: { isModalVisible: boolean, closeModal: () => void }) {

    const [form] = useForm()
    const [download, {isLoading}] = useLazyGetUWExtractionQuery()

    const resetValues = useCallback(() => {
        form.setFieldsValue({
            date_start: moment().subtract(1, "month"),
            date_end: moment(),
        });
    }, [form])

    const onClose = () => {
        closeModal()
        resetValues()
    }

    useEffect(() => {
        resetValues()
    }, [resetValues]);

    const validateEndDate: Rule = ({getFieldValue}) => ({
        validator(_, value: moment.Moment) {
            const startDate = getFieldValue("date_start");
            if (!value || !startDate || value.isSameOrAfter(startDate)) {
                return Promise.resolve();
            }
            return Promise.reject(new Error("La data fine deve essere successiva o uguale alla data inizio"));
        },
    });

    const handleFinish = (values: { date_start: moment.Moment, date_end: moment.Moment }) => {
        const formattedValues = {
            date_start: values.date_start.format("YYYY-MM-DD"),
            date_end: values.date_end.format("YYYY-MM-DD")
        };
        download(formattedValues)
            .then((payload) => {
                if ('error' in payload) {
                    message.error('Errore nel download')
                } else {
                    message.success('Download completato correttamente')
                }
            })
            .catch((error) => {
                message.error('Errore nel download')
            })
            .finally(() => onClose())
    };

    return <ConfirmCancelModal
        open={isModalVisible}
        onCancel={onClose}
        onOk={form.submit}
        destroyOnClose
        title={"Download estrazione UW"}
        okButtonProps={{
                loading: isLoading,
            }}
    >
        <p>Seleziona l'intervallo di tempo per l'estrazione dei dati</p>
        <Form
            form={form}
            layout={"vertical"}
            onFinish={handleFinish}
            style={{marginTop: '1rem'}}
            requiredMark={false}
        >
            <Form.Item
                label={"Data inizio"}
                name={"date_start"}
                rules={[{required: true, message: "Campo obbligatorio"}]}>
                <DatePicker
                    style={{width: "250px"}}
                    format={"DD-MM-YYYY"}/>
            </Form.Item>
            <Form.Item
                label={"Data fine"}
                name={"date_end"}
                dependencies={["date_start"]}
                rules={[{required: true, message: "Campo obbligatorio"}, validateEndDate]}>
                <DatePicker
                    style={{width: "250px"}}
                    format={"DD-MM-YYYY"}/>
            </Form.Item>
        </Form>
    </ConfirmCancelModal>
}